//<Bar dataKey='activeUsers' fill='#1133BB' name='Active Users' />
// {!isOneColumn && (
//   <Bar dataKey='inactiveUsers' fill='#66CC99' name='Inactive Users' />
// )}
import React, { useCallback, useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  TooltipProps,
  XAxis,
  YAxis,
} from 'recharts';
import { FilterByDateWithFlag } from '../lineChart/LineChart';
import Spinner from '../spinner/Spinner';
import { BsFiletypeCsv } from 'react-icons/bs';

interface DataItem {
  name: string;
  [key: string]: string | number;
}

interface Props {
  title?: string;
  data?: DataItem[];
  dataKey1?: string;
  dataKey2?: string;
  name1?: string;
  name2?: string;
  description?: string;
  isFiltering?: boolean;
  isOneColumn?: boolean;
  defaualtFiltering?: string;
  chartName?: any;
  dollar?: boolean;
  setCustomDate?: React.Dispatch<React.SetStateAction<FilterByDateWithFlag>>;
  isLoading?: boolean;
  isShadowBox?: boolean;
  showExport?: boolean;
  isStack?: boolean;
  dataKey3?: string;
  name3?: string;
  barColor1?: string;
}
interface tooltipNewProps extends TooltipProps<any, number> {
  dollar?: boolean;
}
export const CustomTooltip = ({
  active,
  payload,
  label,
  dollar = false,
}: tooltipNewProps) => {
  if (!active || !payload || !payload.length) return null;

  const formatter = (val: number) =>
    dollar
      ? `$${new Intl.NumberFormat('en-US').format(val)}`
      : new Intl.NumberFormat('en-US').format(val);

  return (
    <div className='bg-white border border-gray-300 p-4 rounded shadow-md text-sm'>
      <p className='font-semibold mb-2'>{label}</p>

      {payload.map((entry: any, index: number) => (
        <div key={index} className='flex items-center gap-2 mb-1'>
          {/* المربع الملون */}
          <span
            className='inline-block w-3 h-3 rounded-sm'
            style={{ backgroundColor: entry.color }}
          />
          {/* القيمة */}
          <span className='font-medium' style={{ color: entry.color }}>
            {formatter(entry.value as number)}
          </span>
        </div>
      ))}
    </div>
  );
};

const BarchartComp = ({
  title,
  data = [],
  description,
  isFiltering,
  isOneColumn,
  dataKey1 = 'activeUsers',
  dataKey2 = 'inactiveUsers',
  dataKey3 = '',
  name1 = 'Active Members',
  name2 = 'Inactive Members',
  name3 = 'Inactive Members',
  dollar = false,
  defaualtFiltering = '9',
  setCustomDate,
  chartName,
  isLoading,
  isShadowBox,
  showExport,
  isStack,
  barColor1 = '#1133BB',
}: Props) => {
  const [filter, setFilter] = useState(defaualtFiltering); // Default filter: 3 months
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [dateError, setDateError] = useState<string | null>(null);
  const [maxData, setmaxData] = useState<number>();

  const validateDates = () => {
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);

      if (to <= from) {
        setDateError('The "To" date must be later than the "From" date.');
        return false;
      }
    }
    setDateError(null);
    return true;
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFilter(e.target.value);
  };

  const handleExport = () => {
    const headers = [
      'Month',
      name1 === 'Active Members' ? name2 : name1,
      name2 === 'Inactive Members' ? name1 : name2,
      name3 !== 'Inactive Members' ? name3 : '',
    ];
    if (Object.keys(data[0]).length === 2) {
      headers.splice(1, 1);
      // headers.pop();
    }
    const csvRows = [
      headers.join(','),
      ...data
        .map(row =>
          Object.keys(row)
            .map(key =>
              typeof row[key] === 'number' && dollar
                ? (row[key] as number).toFixed(3)
                : row[key]
            )
            .join(',')
        )
        .reverse(),
    ];

    // Combine rows into a single string
    const csvContent = csvRows.join('\n');

    // Create a Blob for the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `${
      chartName.split(/(?=[A-Z])/).join(' ') || title || 'data'
    } ${data[data.length - 1].name} - ${data[0].name}.csv`; // File name

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up the URL and link
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleDateChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: 'from' | 'to'
  ) => {
    const value = e.target.value;
    if (type === 'from') {
      setFromDate(value);
    } else {
      setToDate(value);
    }
    validateDates();
  };

  // const filteredData = () => {
  //   const today = new Date();
  //   let startDate, endDate;

  //   if (filter === '3') {
  //     endDate = new Date(today.getFullYear(), today.getMonth(), 0);
  //     startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1);
  //     startDate.setHours(12, 0, 0, 0);
  //   } else if (filter === '6') {
  //     endDate = new Date(today.getFullYear(), today.getMonth(), 0);
  //     startDate = new Date(today.getFullYear(), today.getMonth() - 6, 1);
  //     startDate.setHours(12, 0, 0, 0);
  //   } else if (filter === '9') {
  //     endDate = new Date(today.getFullYear(), today.getMonth(), 0);
  //     startDate = new Date(today.getFullYear(), today.getMonth() - 9, 1);
  //     startDate.setHours(12, 0, 0, 0);
  //   } else if (filter === '12') {
  //     endDate = new Date(today.getFullYear(), today.getMonth(), 0);
  //     startDate = new Date(today);
  //     startDate.setFullYear(today.getFullYear(), today.getMonth() - 12, 1);
  //     startDate.setHours(12, 0, 0, 0);
  //   }
  //   if (filter !== 'custom') {
  //     setCustomDate?.({
  //       endDate: endDate?.toISOString() || '',
  //       startDate: startDate?.toISOString() || '',
  //       typeName: chartName || '',
  //     });
  //   }
  // };
  const filteredData = useCallback(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let endDate = today;
    let startDate;

    if (filter === '3') {
      startDate = new Date(
        tomorrow.getFullYear(),
        tomorrow.getMonth() - 2,
        tomorrow.getDate()
      );
    } else if (filter === '6') {
      startDate = new Date(
        tomorrow.getFullYear(),
        tomorrow.getMonth() - 5,
        tomorrow.getDate()
      );
    } else if (filter === '9') {
      startDate = new Date(
        tomorrow.getFullYear(),
        tomorrow.getMonth() - 8,
        tomorrow.getDate()
      );
    } else if (filter === '12') {
      startDate = new Date(today);
      startDate = new Date(
        tomorrow.getFullYear(),
        tomorrow.getMonth() - 11,
        tomorrow.getDate()
      );
    }
    if (filter !== 'custom') {
      setCustomDate?.({
        endDate: endDate?.toISOString().split('T')[0] || '',
        startDate: startDate?.toISOString().split('T')[0] || '',
        typeName: chartName || '',
      });
    }
  }, [filter, chartName, setCustomDate]);

  const handleSubmitDate = () => {
    if (!toDate || !fromDate) return;
    if (validateDates() && setCustomDate) {
      setCustomDate({
        endDate: toDate,
        startDate: fromDate,
        typeName: chartName,
      });
    }
  };

  useEffect(() => {
    filteredData();
  }, [filter, filteredData]);

  useEffect(() => {
    const max = data
      ? Math.max(...data?.map(item => Number(item[dataKey1])))
      : 0;
    setmaxData(max);
  }, [data, dataKey1]);

  return (
    <div
      className={`flex flex-col ${
        isShadowBox && 'border border-gray-200 primary-shadow px-7 pt-7 pb-5'
      }`}
    >
      {title && <h2 className='font-[600] text-xl text-left'>{title}</h2>}
      {data?.length > 0 && (
        <div
          className={`flex ${
            isFiltering ? 'justify-between' : 'justify-end'
          } gap-8 my-8 max-h-10 flex-wrap`}
        >
          {isFiltering && (
            // <div className='select-wrapper'>
            <select
              value={filter}
              onChange={handleFilterChange}
              className='p-2 border border-gray-300 rounded cursor-pointer pr-6 h-10'
            >
              <option value='3'>Last 3 Months</option>
              <option value='6'>Last 6 Months</option>
              <option value='9'>Last 9 Months</option>
              <option value='12'>Last 12 Months</option>
              <option value='custom'>Custom</option>
            </select>
            // </div>
          )}

          {filter === 'custom' && (
            <div className='flex flex-col gap-2'>
              <div className='flex items-center gap-2'>
                <label htmlFor='fromDate'>From</label>
                <input
                  id='fromDate'
                  type='date'
                  value={fromDate}
                  onChange={e => handleDateChange(e, 'from')}
                  className='p-2 border border-gray-300 rounded'
                />
                <label htmlFor='toDate' className='ml-4'>
                  To
                </label>

                <input
                  type='date'
                  id='toDate'
                  value={toDate}
                  onChange={e => handleDateChange(e, 'to')}
                  className='p-2 border border-gray-300 rounded'
                />
                <button
                  className={`border border-gray-300 px-4 py-1 rounded ml-2 h-full  whitespace-nowrap ${
                    !toDate || !fromDate
                      ? 'bg-[#ccc] text-black'
                      : 'bg-[#00C389] text-white'
                  }`}
                  type='button'
                  onClick={handleSubmitDate}
                  disabled={!toDate || !fromDate}
                >
                  Submit Date
                </button>
              </div>
              {dateError && (
                <p className='text-red-500 text-sm text-center'>{dateError}</p>
              )}
            </div>
          )}

          {showExport && !isLoading && data && (
            <button
              onClick={handleExport}
              className='rounded-lg w-[7rem] h-10 text-white bg-[#333399] flex px-2 py-2 items-center justify-center mb-6'
            >
              <span>Export </span> <BsFiletypeCsv className='mx-2' size={22} />
            </button>
          )}
        </div>
      )}
      {isLoading ? (
        <div className='mx-auto my-5'>
          <Spinner />
        </div>
      ) : data?.length > 0 ? (
        <>
          <ResponsiveContainer width='100%' height={300}>
            <BarChart
              data={[...data].reverse()}
              margin={{
                top: 5,
                right: maxData && maxData > 999 ? 30 : 0,
                bottom: 5,
                left: maxData && maxData > 999 ? 30 : 0,
              }}
            >
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='name' />
              <YAxis
                type='number'
                tickFormatter={value =>
                  dollar
                    ? `$${new Intl.NumberFormat().format(value)}`
                    : new Intl.NumberFormat().format(value)
                }
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#fff',
                  border: '1px solid #ddd',
                }}
                content={<CustomTooltip dollar={dollar} />}
                itemStyle={{ background: 'white' }}
                formatter={value => {
                  const formattedValue = new Intl.NumberFormat('en-US').format(
                    +value
                  );
                  return dollar ? `$${formattedValue}` : formattedValue;
                }}
              />
              <Legend />
              <Bar
                dataKey={dataKey1}
                fill={barColor1}
                name={name1}
                {...(isStack ? { stackId: 'a' } : {})}
              />

              {!isOneColumn && (
                <Bar
                  dataKey={dataKey2}
                  fill='#66CC99'
                  name={name2}
                  {...(isStack ? { stackId: 'a' } : {})}
                />
              )}
              {dataKey3 && name3 && (
                <Bar
                  dataKey={dataKey3}
                  fill='#b5b5b5'
                  name={
                    name3 === 'rejected'
                      ? ' rejected/cancelled/refunded'
                      : name3
                  }
                  {...(isStack ? { stackId: 'a' } : {})}
                />
              )}
            </BarChart>
          </ResponsiveContainer>
          <p className='my-4 text-sm text-center mt-6'>{description}</p>
        </>
      ) : (
        <p className='italic text-gray-600 text-center my-2'>
          No data available
        </p>
      )}
    </div>
  );
};

export default BarchartComp;
